module.exports = __webpack_public_path__ + "login_img.jpg";